/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archive_JobInputs */



/**
* | output |
* | --- |
* | "Archive Job" |
*
* @param {Archive_JobInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const archive_job = /** @type {((inputs?: Archive_JobInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archive_JobInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Archiver la tâche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Archivierungsjob")
	if (locale === "it") return /** @type {LocalizedString} */ ("Archivio lavoro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Архив заданий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Trabajo de archivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("存档作业")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アーカイブジョブ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आर्काइव जॉब")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Trabalho de Arquivo")
	return /** @type {LocalizedString} */ ("Archive Job")
});